import type { FaireProductEntity } from "../../entity_types/product";

export const p_9snn75jh87: FaireProductEntity = {
  token: "p_9snn75jh87",
  type: "product",
  name: "Colombo Serving Bowl",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/8c95dd239aebb096de475fadef3ba022c4c90c46e1b0c2b0fe8f1ee11455ad7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c930b3ea3f8b74b53e150b46c1ffb7460b1c11e2170240ba1ca2ef9bc36f5eb.jpeg",
    "https://cdn.faire.com/fastly/962e03cf967710f8a3ed4186e38737b9a29c56c765130fdcb86ad7f6755dd696.jpeg",
    "https://cdn.faire.com/fastly/d50c55b538feb9a1f86d6bc9e5f7382ecf4c224c5571a2154c78043c4a393ba9.jpeg",
    "https://cdn.faire.com/fastly/95d7f3aacaddbe34621ec57281592792d91cbc3c436094ae5296fc0c6e4fd937.jpeg",
    "https://cdn.faire.com/fastly/1cc4168aa2d8b97a5a93dc935c7abc46cf2e884d58e42ad83ff0939415b8c2b7.jpeg",
    "https://cdn.faire.com/fastly/9927c382bfb49cea7bea26386f9c3a64353f8ffc464d71ef9e7bc31d18387917.jpeg",
  ],
  priceDollars: 45,
  description:
    'Colombo is a pleasing dinnerware range inspired by our love of sharing food with friends and family and creating memories around the table.\n\nThe well-considered collection of plates and bowls is perfect for hosting a dinner party for larger group and for making everyday meals for your loved ones special.\n\nColombo range allows you to be creative in how you set your table to best accompany your dishes, mood and needs.\n\nYou can match the colours across the range or mix them, to create your own unique set and add a curated eclectic feel to your table.\n\nBeautifully handcrafted from coloured porcelain – a superior strong and hardwearing ceramic, that if cared for, should last a lifetime. Dishwasher and microwave-safe.\n\nColombo serving bowl is perfect for serving large salads and sharing dishes, or to use as a fruit bowl in the centre of your table.\n\nMaterial: Porcelain\nSize: 29.5 x 8cm / 11.6 x 3.2"',
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:35.396Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
